module.exports = __webpack_public_path__ + "static/media/LalaRukh_1985_documenta14.48459dd7.jpg";